import Header from './components/Header';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Authority from './components/Authority';
import Solutions from './components/Solutions';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const handleWhatsAppClick = () => {
    if (typeof window !== "undefined" && typeof (window as any).gtag_report_conversion === "function") {
      (window as any).gtag_report_conversion();
    }
    window.open(
      'https://wa.me/5512997213362?text=Ol%C3%A1%20Dr.%20Gabriel%2C%20vim%20pelo%20site%20e%20quero%20analisar%20meu%20caso%20de%20bloqueio%20judicial',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />

      {/* 1. Hero — Bloqueio Judicial (tema principal) */}
      <Hero />

      {/* 2. Identificação da dor + Quando pedir desbloqueio + Origem */}
      <Problems />

      {/* 3. Como funciona a atuação (6 steps) */}
      <Solutions />

      {/* 4. FAQ */}
      <Testimonials />

      {/* 5. CTA Final */}
      <FinalCTA />

      {/* 6. Sobre o Dr. Gabriel + Execução Fiscal como autoridade técnica */}
      <Authority />

      {/* 7. Formulário de contato */}
      <Contact />

      <Footer />

      {/* Botão flutuante WhatsApp */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 z-50 w-[88px] h-[88px] flex items-center justify-center bg-green-500 hover:bg-green-600 rounded-full shadow-2xl cursor-pointer transition-colors duration-200 animate-pulse-whatsapp"
        aria-label="Fale pelo WhatsApp"
      >
        <i className="ri-whatsapp-fill text-white text-5xl"></i>
      </button>

      <style>{`
        @keyframes pulse-whatsapp {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
          }
          50% {
            transform: scale(1.08);
            box-shadow: 0 0 0 18px rgba(34, 197, 94, 0);
          }
        }
        .animate-pulse-whatsapp {
          animation: pulse-whatsapp 1.8s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
